import React from 'react';
import '../styles/footer.scss';
function Footer() {
  return (
    <section className="footer">
      <div className="footer-content">
     
      </div>
      <div className="footer-copyright">
      <div className="social-links-footer">
      <a href="https://instagram.com/corinnezoccali" target="_blank" rel="noopener noreferrer" className="social-links-footer small1-icon">
                <img src="./instagram.png" alt="Corinne Zoccali" loading="lazy" />
        </a>
        <a href="https://www.linkedin.com/in/corinnezoccali/" target="_blank" rel="noopener noreferrer" className="social-links-footer small2-icon">
        <img src="./linkedin.png" alt="Corinne Zoccali" loading="lazy" />
        </a>
        </div>
        <p>Corinne Zoccali <br></br>&copy; 2025 All rights reserved.</p>
      </div>
    </section>
  );
}

export default Footer;
